var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useCallback, useMemo, useRef } from "react";
import { clone, equals } from "ramda";
export var LookupInfoContext = createContext(undefined);
var mergeLookupInfo = function (info, newInfo) {
    if (!newInfo) {
        return info;
    }
    var result = clone(info !== null && info !== void 0 ? info : {});
    var hasUpdates = false;
    Object.entries(newInfo).forEach(function (_a) {
        var matchType = _a[0], lookupInfo = _a[1];
        result[matchType] = __assign(__assign({}, (result[matchType] || {})), (lookupInfo || {}));
        hasUpdates = hasUpdates || !equals(result[matchType], info[matchType]);
    });
    hasUpdates = hasUpdates || Object.keys(result).length !== Object.keys(info || {}).length;
    return hasUpdates ? result : info;
};
export var LookupInfoContextProvider = function (_a) {
    var children = _a.children, lookupInfo = _a.lookupInfo, setLookupInfo = _a.setLookupInfo;
    var getLookupInfo = useCallback(function (matchType, matchId) { var _a; return (_a = lookupInfo === null || lookupInfo === void 0 ? void 0 : lookupInfo[matchType]) === null || _a === void 0 ? void 0 : _a[matchId]; }, [lookupInfo]);
    var lookupInfoRef = useRef(lookupInfo);
    lookupInfoRef.current = lookupInfo;
    var updateLookupInfo = useCallback(function (matchType, arg1, arg2) {
        var _a, _b, _c;
        var lookupInfo = lookupInfoRef.current;
        if (matchType && arg1) {
            var update = void 0;
            if (typeof arg1 === "object") {
                update = (_a = {}, _a[matchType] = arg1, _a);
            }
            else if (arg2) {
                update = (_b = {}, _b[matchType] = (_c = {}, _c[arg1] = arg2, _c), _b);
            }
            if (update && lookupInfo) {
                var newLookupInfo = mergeLookupInfo(lookupInfo, update);
                if (newLookupInfo !== lookupInfo) {
                    lookupInfoRef.current = newLookupInfo;
                    setLookupInfo === null || setLookupInfo === void 0 ? void 0 : setLookupInfo(newLookupInfo);
                }
            }
        }
    }, [setLookupInfo]);
    var value = useMemo(function () { return ({ getLookupInfo: getLookupInfo, updateLookupInfo: updateLookupInfo }); }, [getLookupInfo, updateLookupInfo]);
    return React.createElement(LookupInfoContext.Provider, { value: value }, children);
};
//# sourceMappingURL=lookup-info-context.js.map